export default __webpack_public_path__ + "static/media/choose-1.c9a65107.png";